import { render, staticRenderFns } from "./PlexMedia.vue?vue&type=template&id=897153b8&"
import script from "./PlexMedia.vue?vue&type=script&lang=js&"
export * from "./PlexMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports